// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-primary[data-v-412232fa]{width:100%;background-color:#57abf0!important}.modal-top-cover[data-v-412232fa]{position:relative;overflow:hidden;min-height:8rem;border-top-right-radius:.4375rem;border-top-left-radius:.4375rem}.modal-top-cover-avatar[data-v-412232fa]{position:relative;z-index:2;margin-top:-4rem}.modal-close[data-v-412232fa]{display:block;text-align:right;padding-right:8px;padding-top:8px}", ""]);
// Exports
module.exports = exports;
